import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, of } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})

export class PseService {

  private readonly CallbackURL = environment.callback;

  constructor(
    private http: HttpClient,
  ) { }


  pseCallback(token: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', token);
    return this.http.post(`${this.CallbackURL}/pse/consult-state`, null, { headers: headers });
  }
}
